import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "icon"]

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.textContent).then(() => {
      const originalHtml = this.iconTarget.innerHTML
      this.iconTarget.innerHTML = this.checkIcon
      setTimeout(() => {
        this.iconTarget.innerHTML = originalHtml
      }, 1000)
    })
  }

  get checkIcon() {
    return '✓'
  }
}
